export default __webpack_public_path__ + "static/media/github-logo.76901ea5.png";